import React, { SVGProps } from "react";

interface MailIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MailIcon: React.FC<MailIconProps> = ({ className, ...props }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.917 14.9999L12.3813 9.99992M7.61937 9.99992L2.08369 14.9999M1.66699 5.83325L8.47109 10.5961C9.02207 10.9818 9.29756 11.1746 9.59721 11.2493C9.8619 11.3153 10.1387 11.3153 10.4034 11.2493C10.7031 11.1746 10.9786 10.9818 11.5296 10.5961L18.3337 5.83325M5.66699 16.6666H14.3337C15.7338 16.6666 16.4339 16.6666 16.9686 16.3941C17.439 16.1544 17.8215 15.772 18.0612 15.3016C18.3337 14.7668 18.3337 14.0667 18.3337 12.6666V7.33325C18.3337 5.93312 18.3337 5.23306 18.0612 4.69828C17.8215 4.22787 17.439 3.84542 16.9686 3.60574C16.4339 3.33325 15.7338 3.33325 14.3337 3.33325H5.66699C4.26686 3.33325 3.5668 3.33325 3.03202 3.60574C2.56161 3.84542 2.17916 4.22787 1.93948 4.69828C1.66699 5.23306 1.66699 5.93312 1.66699 7.33325V12.6666C1.66699 14.0667 1.66699 14.7668 1.93948 15.3016C2.17916 15.772 2.56161 16.1544 3.03202 16.3941C3.5668 16.6666 4.26686 16.6666 5.66699 16.6666Z"
        stroke="#A4A7AE"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
